import React from "react";
import  ReactDOM  from "react-dom";
import Footer from "./Footer";

function Contact(){
return(
    <div id="myContact"className="contact">
       <h1 className="contact-heading">Contact-Me</h1>
        <div className="contact-form" >
   
           <form action="/contact" method="post">
    <input className="contact-input" type="text" placeholder="Enter your Name"></input>
     <br />
    <input className="contact-input" type="email" placeholder="Enter your email"></input>

    <br />
    <input className="contact-input" type="phone" placeholder="Enter your phone-no"></input>
    <br/>
   <button className=" contact-btn" type="submit">Contact-Me</button>

    </form>
    
    </div>
    <Footer />
    </div>
    
    

);
}



export default Contact;